import React from 'react'

function SectionHeader({ psmItem }) {
    return (
        <div class="mt-5 mb-5 text-center" id='viewUsage'>
            <div class="position-relative">
                <div class="linedetails_main_sec_br"></div>
                <div class="linedetails_main_sec">
                    <p class="section_title_light mb-0 subheading-title">{psmItem?.elementmeta?.title}</p>
                </div>
            </div>
        </div>
    )
}

export default SectionHeader